import { SbBlokData } from "@storyblok/js";
import { useGeneralSettings } from "../../hooks/use-general-settings";
import { StoryblokComponent } from "@made-people/grease-storyblok";
import { useMinicartRecommendations } from "../../hooks/use-minicart-recommendations";
import { SearchResult, SearchResultProvider } from "@made-people/grease-search";
import { MiniCartSwipeableProductList } from "../blueprint/swipeable-product-list/mini-cart-swipeable/default-props";
import { useFrontendContext } from "../../hooks/use-frontend-context";

export const MMCheckoutUpsell = () => {
  const generalSettings = useGeneralSettings();
  const { country } = useFrontendContext();
  const { recommendations, loading } = useMinicartRecommendations("standard");

  const storyblokContent = generalSettings?.miniCartUpsellContent?.map(
    (component: SbBlokData, index: number) => (
      <StoryblokComponent key={index} blok={component} />
    ),
  );

  if (country === "AU" || country === "US" || country === "GB") {
    return null;
  }

  if (loading) {
    return null;
  }

  if (!recommendations.length) {
    return storyblokContent;
  }

  const searchResult: SearchResult = {
    items: recommendations.map((product) => ({
      type: "product",
      product,
    })),
    meta: {
      currentPage: 1,
      totalPages: 1,
      itemsPerPage: recommendations.length,
      totalItems: recommendations.length,
    },
    sort: [],
    facets: [],
  };

  return (
    <SearchResultProvider result={searchResult}>
      <MiniCartSwipeableProductList
        settings={{
          template: "template1",
          itemsInView: {
            initial: "2.5",
            md: "3",
            lg: "4",
            xl: "4",
          },
          headerSettings: {
            heading: {
              heading: "Mini_Cart_Recommendations_Heading",
            },
          },
        }}
      />
    </SearchResultProvider>
  );
};
